import styled from 'styled-components';

import { getSpace, mq } from '@stylesheets/tools';

const StyledIntroduction = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  align-items: center;
  cursor: pointer;

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    backdrop-filter: blur(5px);
  }

  .introduction__content {
    position: relative;
    padding: ${getSpace('m')};
    display: flex;
    flex-direction: column;
    gap: ${getSpace('xxs')};
    width: 100%;

    h1 {
      font-size: 45px;
      line-height: 54px;

      ${mq('m')} {
        font-size: 80px;
        line-height: 105px;
      }
    }

    p {
      max-width: 600px;
    }
  }
`;

export default StyledIntroduction;
